<template>
  <div id="itembank-form">
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Content Banner</li>
      <li class="active">Create</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Tambah Konten</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Form Banner</h4>
          </div>
          <div class="panel-body panel-form" v-if="step == 0">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form class="form-horizontal form-bordered">
              <div class="form-group" >
                <label class="col-md-2 control-label">Pilih Section *</label>
                <div class="col-md-8 col-xs-12">
                  <select class="form-control" v-model="form.section_id">
                    <option :value="item.id" v-for="(item,index) in listSection" v-bind:key="index">{{ item.name }}</option>
                  </select>
                </div>
              </div>
               <div class="form-group">
                 <label class="col-md-2 control-label"></label>
                 <div class="col-md-8 col-xs-12">
                  <button type="button" class="btn btn-success btn-md" @click="nextStep()">Selanjutnya</button>
                 </div>
               </div>
            </form>
          </div>
          <!-- next step next step next step  -->
          <div class="panel-body panel-form" v-if="step == 1">
            <div class="alert alert-danger fade in m-b-15" v-if="this.errors.length > 0">
              <span class="close" data-dismiss="alert">&times;</span>
              <strong>Terjadi kesalahan!</strong>
              <ul>
                <li v-for="(message, key) in this.errors" v-bind:key="key">{{message}}</li>
              </ul>
            </div>
            <form class="form-horizontal form-bordered">
              <div class="form-group" >
                <label class="col-md-2 control-label">Judul</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.name"/>
                </div>
              </div>
              <div class="form-group" v-bind:class="{'has-error': !is_applink_valid, 'has-success': is_applink_valid}">
                <label class="col-md-2 control-label">Link</label>
                <div class="col-md-8 col-xs-12">
                  <span class="btn btn-xs" v-bind:class="{'btn-primary' : isDeeplink}" @click="isDeeplink = true">DEEPLINK</span>
                  <span class="btn btn-xs" v-bind:class="{'btn-primary' : !isDeeplink}" @click="isDeeplink = false; resetDeeplink()">WEB LINK</span><br /><br />
                  <input v-if="!isDeeplink" class="form-control" type="text" v-model="form.link"/>
                  <select v-else class="form-control" v-model="selectedDeeplink">
                    <option v-for="deeplink in this.deeplinks" v-bind:key="deeplink.id" v-bind:value="deeplink.link">{{deeplink.name.toUpperCase()}}</option>
                  </select>
                  <div v-if="deeplinkParam != null" class="input-group">
                    <span class="input-group-addon input-group-xs">{{deeplinkParam.name}}</span>
                    <input type="number" class="form-control" v-model="deeplinkParam.value" />
                  </div>
                  <span v-if="!isDeeplink" class="help-text">must start with <strong>http://</strong> or <strong>https:// </strong></span>
                </div>
              </div>
              <div class="form-group" v-bind:class="{'has-error': !is_url_valid, 'has-success': is_url_valid}">
                <label class="col-md-2 control-label">Link Web</label>
                <div class="col-md-8 col-xs-12">
                  <input class="form-control" type="text" v-model="form.link_web"/>
                  <span class="help-text">must start with <strong>http://</strong> or <strong>https://</strong></span>
                </div>
              </div>
              <div class="form-group">
               <label class="col-md-2 control-label">Upload Asset</label>
                <div class="col-md-8 col-xs-12">
											<div class="row">
												<div class="col-md-4" v-if="url">
													<!-- <img class="img-fluid" :src="form.picture" /> -->
                          <img :src="url" style="max-width:100%;" ref="banner" alt="avatar">
												</div>
												<div class="col-md-8">
													<app-imagecropper v-on:finished="onFileChanged($event)" v-bind:aspectRatio="0.5" />
												</div>
											</div>
										</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-8 col-xs-12">
                  <select class="form-control" v-model="form.status">
                    <option value="PUBLISHED">Published</option>
                    <option value="HIDDEN">Hidden</option>
                  </select>
                </div>
              </div>
               <div class="form-group">
                 <label class="col-md-2 control-label"></label>
                 <div class="col-md-8 col-xs-12">
                  <button v-if="$route.query.id" type="button" class="btn btn-success btn-md" @click="save()">Simpan Perubahan</button>
                  <button v-else type="button" class="btn btn-success btn-md" @click="save()">Simpan</button>
                 </div>
               </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentService from '@/services/content.js'
import URLValidator from '@/services/url_validator.js'
import AppLinkValidator from '@/services/applink_validator.js'
import Spinner from '@/components/plugins/Spinner'
import Modal from '@/components/plugins/Modal'
import ImageCropper from '@/components/plugins/ImageCropper'

export default {
  name: 'content-banner-form',
  components: {
    'app-spinner': Spinner,
    'app-modal': Modal,
    'app-imagecropper': ImageCropper
  },
  data: function() {
    return {
      compiledContent: '',
      labelQuery: '',
      isLoading: false,
      step: 0,
      listSection: [],
      isDeeplink: true,
      deeplinks: [],
      selectedDeeplink: null,
      deeplinkParam: null,
      preventSingleBanner: false,
      form: {
        id: 0,
        name: null,
        link_web: null,
        link: null,
        picture: null,
        status: null,
        section_id: null
      },
      selectedPicture: null,
      errors: [],
      url: null,
      toastAlert: false,
      exceedFileSize: false,
      invalidFileType: false,
      file: null,
      showCropModal: false,
      previewImageUrl: null,
      croppr: null,
      is_applink_valid: false,
      is_url_valid: false
    }
  },
  mounted: function () {
    this.loadSection()
    var context = this

    ContentService.getAllDeeplinks(function(response) {
      if (response.success) {
        context.deeplinks = response.data
      }

      if (context.$route.query.id) {
        context.queryId = context.$route.query.id
        context.fetchData()
      }
    })
  },
  watch: {
    'form.link': function(val) {
      if (val.length == 0) return

      if (this.isDeeplink ) this.is_applink_valid = AppLinkValidator.validate(val)
      else this.is_applink_valid = URLValidator.validate(val)
    },
    'form.link_web': function(val) {
      if (val.length == 0) return
      this.is_url_valid = URLValidator.validate(val)
    },
    'selectedDeeplink': function(val) {
      if (val == null) return

      var paramPattern = /\{.*?\}/g
      var params = val.match(paramPattern)
      if (params != null) this.deeplinkParam = {name: JSON.stringify(params[0]), value: ''}
      else this.deeplinkParam = null

      this.form.link = val
    }
  },
  methods: {
    fetchData: function () {
      var context = this
			var data = this.$store.state.content.editContent
      var content = JSON.parse(data.content)
      this.form = {
        id: data.id,
        name: content.title,
        link_web: content.link_web,
        link: content.link,
        picture: content.image_url,
        status: data.status,
        section_id: data.section.id
      }

      this.url = content.image_url
      this.isDeeplink = AppLinkValidator.validate(this.form.link) ? true : false
      if (this.isDeeplink) {
        var segments = this.form.link.split('/')
        var isParameterized = false

        this.deeplinks.forEach(function(deeplink) {
          if(deeplink.link.split('/').length === segments.length &&
            deeplink.link.includes(segments[segments.length-2]) &&
            deeplink.link.includes("{")) {
              context.selectedDeeplink = deeplink.link
              context.form.link = deeplink.link
              context.deeplinkParam.value = segments[segments.length - 1]
              isParameterized = true
          }
        })

        if (!isParameterized) this.selectedDeeplink = this.form.link
      }
		},
    loadSection: function() {
      var context = this
      ContentService.getContentDetailByType('SINGLE_BANNER',function (result) {
        var tmpData = []
        for(var i =0; i < result.data.length; i++){
          var name = 'SINGLE | ' + result.data[i].name
          result.data[i].name = name

          if(context.$route.query.id || result.data[i].details.length == 0) tmpData.push(result.data[i])
        }

        if(result.success) context.listSection.push(...tmpData)
        else alert('pengambilan section list gagal')
      })
      ContentService.getContentDetailByType('MULTIPLE_BANNER',function (result) {
        for(var i =0; i < result.data.length; i++){
          var name = 'MULTIPLE | ' + result.data[i].name
          result.data[i].name = name
        }
        if(result.success) context.listSection.push(...result.data)
        else alert('pengambilan section list gagal')
      })
    },
    save: function() {
      var context = this
      if (this.isDeeplink && this.deeplinkParam != null) {
        var parameterizedLink = this.form.link.replace(JSON.parse(this.deeplinkParam.name), this.deeplinkParam.value)
        this.form.link = parameterizedLink
      }

      if (!this.isDeeplink && !this.form.link.includes('http')) {
        var httpLink = 'http://' + this.form.link
        this.form.link = httpLink;
      }

      if(this.validateForm()) {
        context.isLoading = true
        if(this.selectedPicture !== null){
          var strJSON = {
            title: this.form.name,
            link_web: this.form.link_web,
            link: this.form.link,
          }
        } else {
          var strJSON = {
            title: this.form.name,
            link_web: this.form.link_web,
            link: this.form.link,
            image_url: this.form.picture
          }
        }

          var conStr = JSON.stringify(strJSON)
          var context = this
          var picture = this.selectedPicture
          var formData = new FormData()
          var dataReq = {
              action: this.form.link,
              content: conStr.replace(/'/g, "\\'"),
              is_active: true,
              section_id: parseInt(this.form.section_id),
              status: this.form.status
            }

        if(!this.$route.query.id) {
            formData.append('req', JSON.stringify(dataReq))
            formData.append('file', picture)

            ContentService.createContentDetail(formData, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/banner' })
              else alert('ada kesalahan')
            })
        } else {
            formData.append('req', JSON.stringify(dataReq))
            if(picture !== null) formData.append('file', picture)

            ContentService.updateContentDetail(this.$route.query.id, formData, function (result) {
              context.isLoading = false
              if (result.success) context.$router.push({ path: '/content/banner' })
              else alert('ada kesalahan')
            })
        }
      }
    },
    onFileChanged(event) {
      this.url = event.url
      this.selectedPicture = event.blob
    },
    validateForm: function() {
      this.errors = []
      if(!this.form.name) this.errors.push('Judul wajib diisi')
      if(!this.form.link) this.errors.push('Link wajib diisi')
      if(!this.url) this.errors.push('Gambar wajib diisi')
      if(!this.form.status) this.errors.push('Status wajib diisi')
      if(!this.form.link_web) this.errors.push('Link Web wajib diisi')
      if(!this.form.section_id) this.errors.push('Pilih section wajib diisi')
      if(!this.is_applink_valid) this.errors.push('App link tidak valid')
      if(!this.is_url_valid) this.errors.push('Web URL tidak valid')
      if(this.deeplinkParam != null && this.deeplinkParam.value == '') this.errors.push('Parameter deeplink harus diisi')
      if(this.errors.length == 0) return true

      return false
    },
    nextStep: function() {
      if(this.form.section_id !== null){
        this.step = 1
      } else {
        alert('Pilih section wajib di isi')
      }
    },
    resetDeeplink: function() {
      this.form.link = ''
      this.is_applink_valid = false
      this.deeplinkParam = null
      this.selectedDeeplink = null
    }
  }
}

</script>



// WEBPACK FOOTER //
// Form.vue?b2f2f9fa